import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AuthProvider } from "./contexts/AuthContext";
import AdminBypassPanel from "./components/AdminBypassPanel";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <AdminBypassPanel />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
